import {HttpClient} from '@angular/common/http';
import {ErrorHandler, Injectable} from '@angular/core';
import {endpoints} from '../constants/endpoints';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {

  constructor(private http: HttpClient) { }

  public handleError(error: any): any {
    try {
      const model = {
        message: error.message ?? '',
        name: error.name ?? '',
        source: error.cause ?? '',
        filename: error.filename ?? '',
        linenumber: error.linenumber ?? 0,
        columnNumber: error.columnNumber ?? 0,
        stack: error.stack ?? ''
      };
      this.http.post(endpoints.error, model).subscribe();
      console.error(error); // uncomment to display all global unhandled errors
    } catch (error ){
      // log to the console.
      console.error(error);
    }
    return error;
  }
}
